var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStocks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.25 18L6.25 13.5L7.75 13.5L7.75 18L6.25 18Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 18V9.5H17.5V18H16Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 18.0002L11 11.2002L12.5 11.2002L12.5 18.0002L11 18.0002Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8 2.75H14.05V4.25H16.1833C16.1557 4.26971 16.1277 4.28958 16.0999 4.30936C15.9501 4.41582 15.8042 4.51957 15.744 4.58082C13.1281 7.24231 9.54692 8.74988 5.79999 8.74988H5.04999V10.2499H5.79999C9.88178 10.2499 13.7859 8.63458 16.6699 5.77667C16.7699 5.67758 16.8748 5.49375 16.9782 5.31269C17.0022 5.27055 17.0262 5.22856 17.05 5.18782L17.05 7.25L18.55 7.25L18.55 3.5C18.55 3.30109 18.471 3.11032 18.3303 2.96967C18.1897 2.82902 17.9989 2.75 17.8 2.75Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStocks);
export default __webpack_public_path__ + "static/media/stocks.ae9e797c5991507bdba0507519f39e4d.svg";
export { ForwardRef as ReactComponent };